import { Component, Input } from '@angular/core';
import { AuctionsWalletItem, MarketplaceWalletItem, RewardsWalletItem, WalletGroupItem, WalletItemType } from '@fgb/core';
import { OwlCarouselSettings } from '@fgb/portal-component-library/src/lib/shared/utilities';
import { OwlOptions } from 'ngx-owl-carousel-o';

@Component({
  selector: 'fgbcl-rewards-wallet-redeem-list',
  templateUrl: './rewards-wallet-redeem-list.component.html',
  styleUrls: ['./rewards-wallet-redeem-list.component.scss'],
})
export class RewardsWalletRedeemListComponent {
  @Input() unRedeemedItems: WalletGroupItem[];
  @Input() marketplaceWalletUrl = `/rewards/wallet/details/`;
  @Input() auctionWalletUrl = `/rewards/bids/details/`;
  @Input() lottoWalletUrl = `/rewards/wallet/raffledetails/`;

  isDragging: boolean = false;
  customOptions: OwlOptions = {
    dots: true,
    margin: 8,
    pullDrag: false,
    autoWidth: true,
    autoplayTimeout: OwlCarouselSettings.AutoplayTimeout,
    autoplaySpeed: OwlCarouselSettings.AutoplaySpeed,
    navSpeed: 700,
    responsive: {
      0: { items: 1, autoWidth: true },
      540: { items: 2, autoWidth: false },
      740: { items: 3 },
    },
  };

  constructor() {}

  getItemDetailUrl(item: RewardsWalletItem): string {
    if (item.ItemType == WalletItemType.Auction) {
      return `${this.auctionWalletUrl}${(item as AuctionsWalletItem).WalletId}`;
    } else if (item.ItemType == WalletItemType.Marketplace) {
      return `${this.marketplaceWalletUrl}${(item as MarketplaceWalletItem).WalletId}`;
    } else if (item.ItemType == WalletItemType.Lotto) {
      return `${this.lottoWalletUrl}${item.WalletId}`;
    }
    return '';
  }
}
